module.exports = __webpack_public_path__ + "assets/img/5d.87fc58ad.png";